import React, { useCallback } from 'react';
import { Field } from 'redux-form';
import { Field as FieldConfig } from '../types/GenericFormTypes';
import { FieldLabelProps, GenericFieldRow } from '../prefabs/GenericFieldRow';
import { GroupFields } from '../prefabs/GroupFields';

interface Props extends FieldLabelProps {
  gap?: number;
  fields: FieldConfig[];
}

export const GenericReduxForm: React.FC<Props> = (props) => {
  const { fields, gap = 16, direction, ...labelConfig } = props;

  const renderField = useCallback(
    (field) => {
      if (!field) return null;

      // Motiv number will be dropped
      if (field.type === 'generated') return null;

      const { format, warn, parse, ...restProps } = field;

      return (
        <Field
          {...restProps}
          key={field.name}
          props={{
            direction,
            ...labelConfig,
            ...restProps
          }}
          component={GenericFieldRow}
          format={format}
          parse={parse}
          validate={field.validate}
          warn={warn}
        />
      );
    },
    [labelConfig]
  );

  return <GroupFields fields={fields} gap={gap} renderField={renderField} />;
};
